import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import styles from './About.module.css';

const STATS = [
  { val: '100%', label: 'Hollywood Free' },
  { val: '$1',   label: 'per vote\nNO Hidden fees' },
  { val: '90',   label: 'Days per voting round' },
  { val: '4',    label: 'Reward tiers per project' },
];

const TRADITIONAL = [
  'Back a project with no guarantee it gets made',
  'No say in which films win or lose',
  'Reward tiers are mostly digital badges',
  'Platform takes a large percentage cut',
  'Films may never be distributed',
];

const VOXPOP_DIFF = [
  'Vote-to-fund model with goal-based greenlight',
  'Your vote directly determines what gets produced',
  'Real rewards: tickets, events, Q&As, screenings',
  'Transparent $1 = 1 vote economy',
  'Films premiere on-platform for the people who made them happen',
];

export default function About() {
  return (
    <div>
      <PageHeader title="about us" />

      <div className={styles.page}>

        {/* Top row — full width with circle + copy */}
        <div className={styles.heroRow}>
          <div className={styles.whyCircle}>
            <span>"Why don't I see more movies like THIS?"</span>
          </div>
          <div className={styles.heroCopy}>
            <p className={styles.body}>
              We're here for the filmmakers shut out by the studios. For the fans who are sick
              of sequels, reboots, and movies created by corporate (or actual) robots.
            </p>
            <p className={styles.body}>
              We're here to give Hollywood the finger and hand power back to the people. To create
              a world where the best films get made because they're good, not because the creator's
              cousin knows someone at Sony.
            </p>
            <p className={styles.body}>
              VoxPop is for the dreamers, the rebels, the film nerds, and the instigators who still
              believe movies should make you feel something other than déjà vu.
            </p>
          </div>
        </div>

        {/* Stats — full width grid */}
        <div className={styles.statsGrid}>
          {STATS.map((s, i) => (
            <div key={i} className={styles.statBox}>
              <div className={styles.statVal}>{s.val}</div>
              <div className={styles.statLabel}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Meet the makers */}
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>Meet <span>the makers</span></h3>
          <p className={styles.body}>
            We're not studio execs (unless your definition of exec is 'person who stayed up all
            night yelling at Final Cut Pro'). We're actors, writers, misfits, and movie nerds
            who've seen one too many brilliant ideas die in Dropbox folders. So we decided to do
            something about it, and VoxPop was born.
          </p>

          <blockquote className={styles.revolutionQuote}>
            <span className={styles.quoteLine}>Every revolution starts with a spark. Every indie film starts with a vote.</span>
            <span className={styles.quoteLine}>Let's light it up!</span>
            <span className={styles.quoteLine}>Hollywood won't save cinema. You will{'\u2009'}!</span>
          </blockquote>

          <p className={styles.body}>
            But you won't find any headshots or LinkedIn bios here, because VoxPop isn't about us.
            It's about YOU. The dreamers. The filmmakers. The voters who know what they like and
            don't see enough of it in theaters. You won't remember our names. But you will remember
            the movies you helped bring to life.
          </p>
        </div>

        {/* How we're different — full width */}
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>How we're <span>different</span></h3>
          <div className={styles.compareGrid}>
            <div className={styles.compareCol}>
              <div className={styles.compareHeader} style={{ color: 'var(--gray)' }}>
                Traditional Crowdfunding
              </div>
              {TRADITIONAL.map((t, i) => (
                <div key={i} className={styles.compareRow}>
                  <span className={styles.xMark}>✕</span>
                  <span>{t}</span>
                </div>
              ))}
            </div>
            <div className={styles.compareCol}>
              <div className={styles.compareHeader} style={{ color: 'var(--red)' }}>
                VoxPop
              </div>
              {VOXPOP_DIFF.map((v, i) => (
                <div key={i} className={styles.compareRow}>
                  <span className={styles.checkMark}>✓</span>
                  <span>{v}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Full width CTA bar */}
      <div className={styles.wantIn}>
        <div className={styles.wantInInner}>
          <div className={styles.wantInLabel}>Want in?</div>
          <div className={styles.wantInRow}>
            <div className={styles.wantInItem}>
              <strong>Movie Lovers:</strong> Join the uprising!
              <Link to="/register" className="btn btn-dark btn-sm" style={{ marginTop: 10 }}>Sign Up</Link>
            </div>
            <div className={styles.wantInDivider} />
            <div className={styles.wantInItem}>
              <strong>Filmmakers:</strong> Escape Development Hell!
              <Link to="/contact" className="btn btn-dark btn-sm" style={{ marginTop: 10 }}>Contact Us</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
